import { cva } from '@/styled-system/css';

export const alertRecipe = cva({
  base: {
    display: 'flex',
    paddingBlock: 'default',
    paddingInline: 'default',
    borderRadius: 'obj.default',
    borderWidth: 'default',
    borderStyle: 'solid',
  },
  variants: {
    tone: {
      critical: {
        backgroundColor: 'Alert.critical.bg',
        borderColor: 'Alert.critical.border',
      },
      info: {
        backgroundColor: 'Alert.info.bg',
        borderColor: 'Alert.info.border',
      },
      success: {
        backgroundColor: 'Alert.success.bg',
        borderColor: 'Alert.success.border',
      },
      warning: {
        backgroundColor: 'Alert.warning.bg',
        borderColor: 'Alert.warning.border',
      },
    },
  },
});
